export function textToHtml(data) {
  try {
    const decoded = JSON.parse(data);
    return (
      <div
        className="prose-sm xl:prose 2xl:prose-lg w-full max-w-none mt-1"
        dangerouslySetInnerHTML={{ __html: decoded }}
      />
    );
  } catch (error) {
    if (data?.length > 0) {
      return (
        <p className="text-mobile sm:text-sm 2xl:text-base text-gray-900 font-medium mt-1 leading-5">
          {data}
        </p>
      );
    } else {
      return (
        <p className="text-mobile sm:text-sm 2xl:text-base text-gray-900 font-medium mt-1 leading-5"></p>
      );
    }
  }
}

export function textToHtmlNotice(data) {
  try {
    const decoded = JSON.parse(data);
    return (
      <div
        className="!max-w-none prose-sm xl:prose 2xl:prose-lg mt-1"
        dangerouslySetInnerHTML={{ __html: decoded }}
      />
    );
  } catch (error) {
    if (data.length > 0) {
      return (
        <p className="text-mobile sm:text-sm 2xl:text-base text-gray-900 font-medium mt-1 leading-5">
          {data}
        </p>
      );
    }
  }
}

export function textToHtmlPrint(data) {
  try {
    const decoded = JSON.parse(data);
    return (
      <div
        className="prose-sm 2xl:prose w-full max-w-none pt-1 bg-white"
        dangerouslySetInnerHTML={{ __html: decoded }}
      />
    );
  } catch (error) {
    if (data.length > 0) {
      return (
        <p className="text-mobile sm:text-sm 2xl:text-base text-gray-900 font-medium mt-1 leading-5">
          {data}
        </p>
      );
    }
  }
}

export function textToHtmlTinyMCE(data) {
  try {
    const decoded = JSON.parse(data);
    return (
      <div className="mb-1" dangerouslySetInnerHTML={{ __html: decoded }} />
    );
  } catch (error) {
    if (data.length > 0) {
      return (
        <p className="text-mobile sm:text-sm 2xl:text-base text-gray-900 font-medium mt-1 leading-5">
          {data}
        </p>
      );
    } else {
      return (
        <p className="text-mobile sm:text-sm 2xl:text-base text-gray-900 font-medium mt-1 leading-5"></p>
      );
    }
  }
}

export function textToHtmlTinyMCEBoard(data) {
  try {
    const decoded = JSON.parse(data);
    return (
      <>
        {/* Render HTML content directly here, no extra wrapper */}
        <div dangerouslySetInnerHTML={{ __html: decoded }} />
      </>
    );
  } catch (error) {
    if (data.length > 0) {
      return (
        <p className="text-mobile sm:text-sm 2xl:text-base text-gray-900 font-medium mt-1 leading-5">
          {data}
        </p>
      );
    } else {
      return (
        <p className="text-mobile sm:text-sm 2xl:text-base text-gray-900 font-medium mt-1 leading-5"></p>
      );
    }
  }
}

export function textToHtmlTinyMCEMobile(data) {
  try {
    const decoded = JSON.parse(data);
    return (
      <div
        className="mb-1 prose-sm"
        dangerouslySetInnerHTML={{ __html: decoded }}
      />
    );
  } catch (error) {
    if (data.length > 0) {
      return (
        <p className="text-mobile sm:text-sm 2xl:text-base text-gray-900 font-medium mt-1 leading-5">
          {data}
        </p>
      );
    } else {
      return (
        <p className="text-mobile sm:text-sm 2xl:text-base text-gray-900 font-medium mt-1 leading-5"></p>
      );
    }
  }
}

export function formatTime(seconds) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);

  const parts = h > 0 ? [h, m, s] : [m, s];
  return parts.map((v) => String(v).padStart(2, "0")).join(":");
}
